export const DialogClass = {
	root: 'gov-dialog',
	dialog: 'gov-dialog__dialog',
	inner: 'gov-dialog__inner',
	header: 'gov-dialog__header',
	title: 'gov-dialog__title',
	content: 'gov-dialog__content',
	close: 'gov-dialog__close',
	footer: 'gov-dialog__footer',
	bodyFix: 'body-fixed',
}
